import React, { createContext, useContext, useState, useEffect } from 'react';
import ReactPixel from 'react-facebook-pixel';
import useHistoryParams from './useHistoryParam';
import { useTranslation } from 'react-i18next';

// Create the PromoContext
const PromoContext = createContext();

// Custom hook to use PromoContext
export const usePromo = () => useContext(PromoContext);

// PromoProvider component
export const PromoProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const { params, updateParams } = useHistoryParams();
  const [promo, setPromo] = useState(0.5);

useEffect(() => {
  const pixelParam = params.get('p');
  const promoAmount = params.get('promo');
  const milesAmount = params.get('miles');
  const clickParam = params.get('click_id');
  const langParam = params.get('lang'); // ✅ get language param

  if (clickParam) {
    localStorage.setItem('clickParam', clickParam);
  }

  if (pixelParam) {
    ReactPixel.init(pixelParam);
    console.log('Facebook Pixel initialized with:', pixelParam);
  }

  if (milesAmount) {
    localStorage.setItem('miles', milesAmount);
  }

  if (promoAmount) {
    setPromo((100 - promoAmount) / 100);
    console.log('Promo amount set to:', (100 - promoAmount) / 100);
  }

  // ✅ Change language
  if (langParam && (langParam === 'ar' || langParam === 'en')) {
    i18n.changeLanguage(langParam);
    localStorage.setItem('i18nextLng', langParam); // optional: persist language
  }

  // Remove all used params
  if (pixelParam || promoAmount || clickParam || milesAmount || langParam) {
    updateParams({ p: null, promo: null, click_id: null, miles: null, lang: null });
  }
}, [params, updateParams]);

  return (
    <PromoContext.Provider value={promo}>
      {children}
    </PromoContext.Provider>
  );
};
